import { PARTNER_TYPES } from '../../partner-types';
import { PARTNER_FEATURE_FLAGS } from '../../partner-features';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const fleetManagementSection: MenuItem[] = [
  {
    headTitle1: 'Fleet Management',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    excludedPartners: ['ryd'],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
  },
  {
    title: 'Vehicles',
    icon: 'car',
    iconf: 'car',
    type: 'link',
    path: '/fleet/my-fleet/vehicles',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    excludedPartners: ['ryd'],
    hiddenForSubFleet: true,
  },
  {
    title: 'Drivers',
    icon: 'id-card',
    iconf: 'id-card',
    type: 'link',
    path: '/fleet/my-fleet/driver-management',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    excludedPartners: ['ryd'],
    hiddenForSubFleet: true,
  },
  {
    title: 'Driver Login Access',
    icon: 'lock',
    iconf: 'lock',
    type: 'link',
    path: '/fleet/my-fleet/driver-login-access',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    excludedPartners: ['ryd'],
    requiresRydEmailDomain: true,
  },
  {
    title: 'Transactions',
    icon: 'arrow-left-right',
    iconf: 'arrow-left-right',
    type: 'link',
    path: '/fleet/my-fleet/order-management',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    excludedPartners: ['ryd'],
    // Keep "Transactions" highlighted when a fleet partner opens the
    // transaction detail page (redirected from the shared partner URL).
    activePathPrefixes: ['/fleet/my-fleet/transaction-detail'],
    hiddenForSubFleet: true,
  },
  {
    title: 'Transactions',
    icon: 'arrow-left-right',
    iconf: 'arrow-left-right',
    type: 'link',
    path: '/fleet/my-fleet/sf-transactions',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    excludedPartners: ['ryd'],
    // Keep "Transactions" highlighted on the sf transaction detail page.
    activePathPrefixes: ['/fleet/my-fleet/sf-transactions/'],
    requiresSubFleet: true,
  },
  {
    title: 'Savings Calculator',
    icon: 'stroke-ecommerce',
    iconf: 'fill-ecommerce',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    excludedPartners: ['ryd'],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    requiresPartnerFeature: PARTNER_FEATURE_FLAGS.SAVINGS_CALCULATOR,
    children: [
      {
        path: '/fleet/savings-calculator',
        title: 'Calculator',
        type: 'link',
        active: false,
        requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
      },
      {
        path: '/fleet/savings-calculator/saved',
        title: 'Saved Calculations',
        type: 'link',
        active: false,
        requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
      },
    ],
  },
  {
    title: 'Export Center',
    icon: 'stroke-download',
    iconf: 'fill-download',
    path: '/fleet/export-center',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    excludedPartners: ['ryd'],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
    requiresPaidFleetPlanOrFeature: PARTNER_FEATURE_FLAGS.EXPORT_CENTER,
  },
];
